import gql from 'graphql-tag';

export default gql`
  mutation removeByIdConsultationMutation($_id: MongoID!) {
    removeByIdConsultationMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
